import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.7501 8.5L14.2501 12H16.8751C16.8751 14.8962 14.5213 17.25 11.6251 17.25C10.7413 17.25 9.90134 17.0312 9.17509 16.6375L7.89759 17.915C8.97384 18.5975 10.2513 19 11.6251 19C15.4926 19 18.6251 15.8675 18.6251 12H21.2501L17.7501 8.5ZM6.375 12C6.375 9.10375 8.72875 6.75 11.625 6.75C12.5088 6.75 13.3488 6.96875 14.075 7.3625L15.3525 6.085C14.2763 5.4025 12.9988 5 11.625 5C7.7575 5 4.625 8.1325 4.625 12H2L5.5 15.5L9 12H6.375Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
